export const groupPlayersByStatus = (players) => {
    return players.reduce(
        (statuses, player) => {
            statuses[player.isSubstitute ? 'substitutes' : 'rostered'].push(player);
            return statuses;
        },
        { substitutes: [], rostered: [] }
    );
};
